<template>
  <div id="app">
    <navBar></navBar>
    <router-view />
  </div>
</template>
<script>
import navBar from "@/components/navComponent.vue";

export default {
  name: "home",
  components: {
    navBar,
  },
};
</script>